import React, { useRef } from 'react'
import { IoVolumeHigh } from "react-icons/io5"

export default function StartScreen({ setUserInteracted }) {

    const ref = useRef()

    function handleClick() {
        ref.current.classList.add('hide')
        setTimeout(() => {
            setUserInteracted(true)
            ref.current.remove()
        }, 2000)
    }


    return (
        <div className='startScreen' ref={ref} onClick={handleClick}>
            <IoVolumeHigh className='icon' />
            <h2>VOLUME UP</h2>
            <h3>Click anywhere to start</h3>
        </div>
    )
}
